var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',_vm._b({style:(_vm.mergedStyle),on:{"click":function($event){return _vm.$emit('click')}}},'van-button',_vm.buttonProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }